<template>
  <div class="item b-img">
    <div class="title">
      한도 내에서 필요할 때<br>
      <b>언제든지 사용 가능</b>
    </div>
    <div class="content">
      갑작스런 매출의 변동,<br>
      재료비 직원 월급 지출에 대비하세요!
    </div>
    <div class="content2">
      <div class="item-detail">
        <div class="icon">
          <img src="@/assets/images/main/SectionReason/icon1-1.svg"/>
        </div>
        <div class="desc">
          매출하락
        </div>
      </div>

      <div class="item-detail">
        <div class="icon">
          <img src="@/assets/images/main/SectionReason/icon1-2.svg"/>
        </div>
        <div class="desc">
          재료비
        </div>
      </div>

      <div class="item-detail">
        <div class="icon">
          <img src="@/assets/images/main/SectionReason/icon1-3.svg"/>
        </div>
        <div class="desc">
          인건비
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'One'
}
</script>

<style lang="scss" scoped>
  .item {
    width: 280px;
    height: 340px;
    border-radius: 6px;
    box-shadow: 8px 10px 20px 0 rgba(0, 0, 0, 0.12);
    padding-top: 23px;
    background-image: url("../../../../assets/images/main/SectionReason/bg1.png");
    overflow: hidden;

    .title {
      font-weight: 500;
      font-size: 20px;
      line-height: 1.35;
      letter-spacing: -0.63px;
      text-align: center;
      color: #333333;
      b {
        font-weight: 800;
        color: #333333;
      }
    }

    .content {
      font-weight: 500;
      font-size: 15px;
      line-height: 1.4;
      letter-spacing: -0.47px;
      text-align: center;
      color: #727d8c;
      margin-top: 9px;
    }

    .content2 {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      margin-top: 52px;

      .item-detail {
        flex: 1;

        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .desc {
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 15px;
          line-height: 1.4;
          letter-spacing: -0.47px;
          text-align: center;
          color: #333333;
          margin-top: 15px;
        }
      }
    }
  }
</style>
